import React, { Fragment, useState } from 'react'
import "./NotFoundView.less"
import errorPage from '@assets/images/errorPage.png'
const NotFoundPage = (props) => {
  const [visible, setVisible] = useState(false);
  const isMobile = props.params.terminalType === '3'
  const { Button } = isMobile ? window['TinperM'] : TinperNext;
  return (<div className='errorPage'>
    <img src={errorPage} alt="服务出错图" className={isMobile ? 'errorPage-img-mobile' : 'errorPage-img'} />
    <p className='errorPage-text'>{"抱歉，服务出错了~"}</p>
    {visible && <p className='errorPage-subText'>{props.text || 'not found data'}</p>}
    <div className="errorPage-btn">
      <Button onClick={() => setVisible(!visible)}>{visible ? "收起" : "查看错误码代码"}</Button>
      {/* <Button onClick={() => setVisible(!visible)}>{visible ? "收起" : "查看错误码代码"}</Button> */}
    </div>
  </div>)
}
export default NotFoundPage;

